module.exports = __webpack_public_path__ + "img/Image 10.5e4fd20a.png";